<template>
    <div class="footer">
        <div class="row center-xs footer-line">
            <div class="col-xs-12">
                <p>
                    <router-link to="/terms-and-conditions/53XXkDDUWbcqYMKNZVBh1H">Termos e Condições</router-link> |
                    <router-link to="/privacy-policy/4nSgVhOh00rIzrJOcsqUQe">Privacidade</router-link> |
                    <router-link to="/cookie-policy/4rixlqla9uYcjq1AYkcarH">Política de Cookies</router-link>
                </p>
            </div>
        </div>
        <div class="row center-xs footer-line">
            <div class="col-xs-12">
                <a href="https://www.instagram.com/cota8086/" target="_blank">
                    <i class="fab fa-instagram icon"></i>
                </a>
                <a href="https://www.facebook.com/Cota80.86/" target="_blank">
                    <i class="fab fa-facebook-f icon"></i>
                </a>
                <a href="https://twitter.com/80_cota" target="_blank">
                    <i class="fab fa-twitter icon"></i>
                </a>
            </div>
        </div>
        <div class="row center-xs footer-line">
            <div class="col-xs-12"><p>© cota.80.86</p></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style lang="scss" scoped>
    @import "../assets/styles/global";

    .footer {
        padding-top: 2em;
        padding-bottom: 2em;
        background-color: $primary;

        .footer-line {
            margin-top: 0.5em;
            margin-bottom: 0.5em;
        }
    }

    .icon {
        color: $bgcolor;
        margin-right: 0.5em;
        margin-left: 0.5em;
    }

    p {
        color: $bgcolor;
        font-family: "Work Sans", serif;
        font-size: x-small;
        line-height: 0.1em;
        letter-spacing: 0.1em;
        text-transform: uppercase;
    }

    a {
        color: $bgcolor;
    }

</style>
